export const TEMPLATES_JSON = `
[
  {
    "name": "App",
    "type": "app",
    "attributes": [
      {
        "type": "name",
        "attr": "name",
        "name": "Name",
        "desc": "The name of the app",
        "quant": "1!"
      },
      {
        "type": "activity",
        "attr": "screens",
        "name": "Screens",
        "desc": "The screens",
        "quant": "n!"
      },
      {
        "type": "stream",
        "attr": "singletons",
        "name": "Global Components",
        "desc": "The global components",
        "quant": "n?"
      }
    ]
  },
  {
    "name": "Stream",
    "type": "stream",
    "attributes": [
      {
        "type": "name",
        "attr": "name",
        "name": "Name",
        "desc": "The name of the view",
        "quant": "1!"
      }
    ]
  },
  {
    "name": "Screen",
    "type": "activity",
    "attributes": [
      {
        "type": "viewmodel",
        "attr": "vms",
        "name": "View Model",
        "desc": "The VMs of the screen",
        "quant": "n!"
      },
      {
        "type": "view",
        "attr": "rootView",
        "name": "The View",
        "desc": "The root view",
        "quant": "1!"
      },
      {
        "type": "uiEvent",
        "attr": "uiEvents",
        "name": "The Ui Events",
        "desc": "The Ui Events of this screen",
        "quant": "n?"
      }
    ]
  },
  {
    "name": "Ui Event",
    "type": "uiEvent",
    "attributes": [
      {
        "type": "name",
        "attr": "name",
        "name": "Name",
        "desc": "The name",
        "quant": "1!"
      },
      {
        "type": "text",
        "attr": "params",
        "name": "Params tbd",
        "desc": "PARAMS bla",
        "quant": "n?"
      }
    ]
  },
  {
    "name": "VM",
    "type": "viewmodel",
    "attributes": []
  },
  {
    "name": "State",
    "type": "state",
    "attributes": []
  },
  {
    "name": "State Changer",
    "type": "stateChanger",
    "attributes": []
  },
  {
    "name": "Custom View",
    "type": "view",
    "attributes": [
      {
        "type": "name",
        "attr": "name",
        "name": "Name",
        "desc": "The name of the view",
        "quant": "1!"
      },
      {
        "type": "state",
        "attr": "states",
        "name": "State",
        "desc": "The states held by this component",
        "quant": "n?"
      },
      {
        "type": "ui-binding",
        "attr": "bindings",
        "name": "Binding",
        "desc": "A binding hooked to state attribute(s) to dynamically change its' state",
        "quant": "n?"
      },
      {
        "type": "ui-action",
        "attr": "uiActions",
        "name": "Ui-Action",
        "desc": "Action that is fired from this view",
        "quant": "n?"
      },
      {
        "type": "ui-single-reaction",
        "attr": "uiSingleActions",
        "name": "Ui-Reaction",
        "desc": "One-time reaction reflected on/with the view",
        "quant": "n?"
      },
      {
        "type": "text",
        "attr": "spec",
        "name": "Spec",
        "desc": "Specification of desired behavior",
        "quant": "1!"
      },
      {
        "type": "view",
        "attr": "childViews",
        "name": "Child View",
        "desc": "The child views contained in this view",
        "quant": "n?"
      },
      {
        "type": "view_composition",
        "attr": "childViewComposition",
        "name": "Child View Composition",
        "desc": "The child views contained in this view",
        "quant": "1?"
      }
    ]
  },
  {
    "name": "Ui Binding",
    "type": "ui-binding",
    "refType": "target",
    "attributes": [
      {
        "type": "name",
        "attr": "name",
        "name": "Name",
        "desc": "The name of the binding",
        "quant": "1!"
      },
      {
        "type": "label",
        "attr": "attribute",
        "name": "Attribute",
        "desc": "The attribute to be changed",
        "quant": "1!"
      },
      {
        "type": "ui-binding-attr-case",
        "attr": "cases",
        "name": "Value Cases",
        "desc": "The (potentially various) values this attribute should be set to",
        "quant": "n!"
      }
    ]
  },
  {
    "name": "Ui Binding Attribute Case",
    "type": "ui-binding-attr-case",
    "attributes": [
      {
        "type": "name",
        "attr": "name",
        "name": "Name",
        "desc": "The name of the case",
        "quant": "1!"
      },
      {
        "type": "label",
        "attr": "case",
        "name": "Case rule",
        "desc": "The rule if met leads to value",
        "quant": "1!"
      },
      {
        "type": "label",
        "attr": "case_value",
        "name": "Value",
        "desc": "The value to be used if rule is met",
        "quant": "1!"
      }
    ]
  },
  {
    "name": "Ui Action",
    "type": "ui-action",
    "refType": "target",
    "attributes": [
      {
        "type": "name",
        "attr": "name",
        "name": "Name",
        "desc": "The name of the binding",
        "quant": "1!"
      },
      {
        "type": "state",
        "attr": "in",
        "name": "State Input",
        "desc": "A state/attribute that is used when emitting the events",
        "quant": "n?"
      },
      {
        "type": "ui-event",
        "attr": "out",
        "name": "Event Output",
        "desc": "The events this view is emitting when this action is happening",
        "quant": "n?"
      }
    ]
  },
  {
    "name": "Single Action",
    "type": "ui-single-reaction",
    "refType": "target",
    "attributes": [
      {
        "type": "name",
        "attr": "name",
        "name": "Name",
        "desc": "The name of the binding",
        "quant": "1!"
      },
      {
        "type": "state",
        "attr": "in",
        "name": "State Input",
        "desc": "A state/attribute that triggers this reation",
        "quant": "n!"
      }
    ]
  },
  {
    "name": "Snackbar",
    "parentType": "view",
    "type": "snackbar",
    "attributes": [
      {
        "type": "name",
        "attr": "name",
        "name": "Name",
        "default": "Snackbar",
        "desc": "The name of the snackbar",
        "quant": "1!"
      },
      {
        "type": "state",
        "attr": "in",
        "name": "State Input",
        "desc": "A state/attribute that triggers showing this snackbar",
        "quant": "1!"
      },
      {
        "type": "select",
        "attr": "duration",
        "name": "Duration",
        "selectValues": [
          {
            "label": "Short",
            "desc": "This snackbar is only shown for 1 sec",
            "value": "short"
          },
          {
            "label": "Long",
            "desc": "This snackbar is shown for 3 secs",
            "value": "long"
          },
          {
            "label": "Indefinitely",
            "desc": "This snackbar is shown until dismissed",
            "value": "indef"
          }
        ],
        "default": "long",
        "desc": "The duration this snackbar should be shown for",
        "quant": "1!"
      }
    ]
  }
]
`;



// WEBPACK FOOTER //
// ./src/templates.js